import { getBackendBaseUrl } from '@/services/config/env';

/** Built-in full-frame backgrounds served from the pitch API. */
export const VIDEO_BACKGROUND_TEMPLATES = [
  { id: 'studio-dark', name: 'Dark studio' },
  { id: 'studio-warm', name: 'Warm studio' },
  { id: 'gradient-blue', name: 'Blue gradient' },
  { id: 'gradient-teal', name: 'Teal gradient' },
  { id: 'office-soft', name: 'Soft office' },
  { id: 'spotlight', name: 'Spotlight' },
];

export function backgroundTemplateApiPath(templateId) {
  const id = String(templateId || '').trim();
  if (!id) return '';
  return `/api/pitch/background-templates/${id}/image`;
}

export function backgroundTemplateImageUrl(templateId) {
  const path = backgroundTemplateApiPath(templateId);
  if (!path) return '';
  const base = getBackendBaseUrl();
  return base ? `${base.replace(/\/$/, '')}${path}` : path;
}

export function resolveBackgroundTemplate(templateId) {
  const id = String(templateId || '').trim();
  if (!id) return null;
  const meta = VIDEO_BACKGROUND_TEMPLATES.find((t) => t.id === id);
  if (!meta) return null;
  return {
    ...meta,
    imageUrl: backgroundTemplateImageUrl(id),
  };
}

export function isKnownBackgroundTemplateId(templateId) {
  const id = String(templateId || '').trim();
  return Boolean(id && VIDEO_BACKGROUND_TEMPLATES.some((t) => t.id === id));
}
